// eslint-disable-next-line max-classes-per-file
export interface FilterAttribute {
  propertyName: string;
  displayName: string;
  textToMatch: string;
  attributeType: FilterAttributeType;
}

export class LocalFilterAttribute implements FilterAttribute {
  public propertyName: string;
  public displayName: string;
  public textToMatch: string;
  public attributeType = FilterAttributeType.String;
}

export class ApiFilterAttribute implements FilterAttribute {
  public propertyName: string;
  public displayName: string;
  public textToMatch: string;
  public attributeType = FilterAttributeType.String;

  public apiRoute: string;
  public filterResult: any[];
}

export enum FilterAttributeType {
  String = 1,
  Number = 2,
  Date = 3
}
